<template>
  <main class="lp">
    <ContentsHeader />
    <article class="main_content">
      <div class="pankuzu">
        <ol class="breadcrumb float-sm-right">
          <li class="breadcrumb-item"><a :href="topurl()">トップ</a></li>
          <li class="breadcrumb-item" v-if="false">
            <a :href="categoryurl()">カテゴリ一覧</a>
          </li>
          <li class="breadcrumb-item active">{{ title }}</li>
        </ol>
      </div>

      <div class="lp_link_list__wrapper lp_link_list__wrapper--top">
        <h1 class="category_title">
          {{ title }}
        </h1>
        <p class="category_title__description">
          やりたいことを選んで、ぴったりのサービスを無料チェック
        </p>
        <p class="category_title__update_date">
          更新:2023年3月9日
        </p>
        <div class="start_interview_mark">
          <div class="start_interview_mark_overlay">
            <div class="start_interview_mark__background"><img src="@/assets/r29.svg" width="48" height="48" /></div>
          </div>
          <div class="start_interview_mark_overlay start_interview_mark_overlay--ar">
            <div class="start_interview_mark__background"><img src="@/assets/vecotr.svg" width="48" height="48" /></div>
          </div>
          <div class="start_interview_mark_overlay start_interview_mark_overlay--tx">
            <div class="start_interview_mark__background start_interview_mark__background--tx">導入・見直しを検討中の方は</div>
          </div>
        </div>
        <div class="start_interview_wrapper">
          <section class="start_interview">
            <p class="start_interview__description">
              かんたん・無料・３分
            </p>
            <h2 class="start_interview__title">
              {{ lead }}
            </h2>
            <section class="start_interview__main_content">
              <span class="start_interview__privacy_policy"><a :href="termsurl()">利用規約</a>と<a
                  :href="policyurl()">プライバシーポリシー</a>に同意のうえ、</span>
              <h2 class="start_interview_expectations_title">
                やりたいことを選んでください（複数選択可）
              </h2>
              <div class="start_interview_expectations__candidates start_interview_expectations__candidates--lp">
                <template v-for="(item, index) in page.expectations" :key="index">
                  <h2 v-on:click="page.select(item.id)" class="lpbtn"
                    :class="[isSelected(item.id) ? 'lpbtn--selected' : '']"
                    style="position: relative; padding-left: 36px">
                    {{ item.title }}
                    <p class="lpbtn__description" v-if="false"></p>
                    <img v-if="!isSelected(item.id)" style="position: absolute; top: 18px; left: 8px" width="20"
                      height="20" src="@/assets/check_outlined.svg" />
                    <img v-if="isSelected(item.id)" style="position: absolute; top: 18px; left: 8px" width="20"
                      height="20" src="@/assets/check_filled.svg" />
                  </h2>
                </template>
              </div>

              <button class="start_interview_btn btn_primary" :class="[!page.isSelected() ? 'btn_primary--disabled' : '']"
                v-on:click="startInterview()">
                診断を開始
              </button>
              <p class="start_interview_goto_freeword">上記に当てはまらない場合</p>
              <button class="start_interview_btn btn_outline_primary" v-on:click="gotoFreeword">
                フリーワードで検索
              </button>
            </section>
          </section>

        </div>
      </div>
      <div class="self_introduction_lp">
        <p class="self_introduction_lp__subtitle" v-if="false">BtoBサービス診断</p>
        <h2 class="self_introduction_lp__header">BtoBサービス診断 FitGapなら</h2>

        <div class="self_introduction_lp__container">
          <div class="self_introduction_lp_item">
            <img class="self_introduction_lp_item__logo" src="@/assets/require.svg" />
            <div class="self_introduction_lp_info">
              <h3 class="self_introduction_lp_item__header">
                自社向けのシステム要件<span style="font-weight: initial">を整理できる</span>
              </h3>
              <p class="self_introduction_lp_item__body" v-if="false">
                自社にとってどのような機能その他条件が必要かを整理できます。
              </p>
            </div>
          </div>
          <div class="self_introduction_lp_item self_introduction_lp_item--center">
            <img class="self_introduction_lp_item__logo" src="@/assets/service.svg" />
            <div class="self_introduction_lp_info">
              <h3 class="self_introduction_lp_item__header">
                自社にぴったりのサービス<span style="font-weight: initial">が分かる</span>
              </h3>
              <p class="self_introduction_lp_item__body" v-if="false">
                どのサービスが自社のシステム要件に合うかがわかります。
              </p>
            </div>
          </div>
          <div class="self_introduction_lp_item">
            <img class="self_introduction_lp_item__logo" src="@/assets/feature.svg" />
            <div class="self_introduction_lp_info">
              <h3 class="self_introduction_lp_item__header">
                各サービスの料金、強み注意点、市場シェア<span style="font-weight: initial">などを知れる</span>
              </h3>
              <p class="self_introduction_lp_item__body" v-if="false">
                各サービスの料金、強み注意点、市場シェアなどを知ることができます。
              </p>
            </div>
          </div>
          <div style="width:16px; height: 8px;"></div>
        </div>
      </div>
      <div class="lp_link_list__wrapper lp_link_list__wrapper--noshadow">
        <section class="top_link_list">
          <div class="category_link_list_session" v-if="false">
            <h2 class="category_link_list_session__header">
              電子契約ソフトに関連する製品
            </h2>
            <ul class="category_link_list_session__list" v-if="false">
              <li class="category_link_list_session__item">
                <a class="category_link_list_session__item_link" href="">わにわに</a>
                <img class="category_link_list_session__icon" src="@/assets/arrow_right.svg" />
              </li>
              <li class="category_link_list_session__item">
                <a class="category_link_list_session__item_link" href="">かにかに</a>
                <img class="category_link_list_session__icon" src="@/assets/arrow_right.svg" />
              </li>
              <li class="category_link_list_session__item category_link_list_session__item--last">
                <a class="category_link_list_session__item_link" href="">その他 カテゴリ一覧</a>
                <img class="category_link_list_session__icon" src="@/assets/arrow_right.svg" />
              </li>
            </ul>
          </div>
          <div class="category_link_list_session category_link_list_session--first">
            <h2 class="category_link_list_session__header">
              {{ title }}&nbsp;に関連するカテゴリ
            </h2>
            <ul class="category_link_list_session__list" v-if="true">
              <template v-for="(item, index) in page.categories" :key="index">
                <li class="category_link_list_session__item" :class="[
                  page.categories.length == index + 1
                    ? 'category_link_list_session__item--last'
                    : '',
                ]">
                  <a class="category_link_list_session__item_link" :href="lpsearchurl(item.getId())"
                    :title="item.getTitle()">{{ item.getTitle() }}</a>
                  <img class="category_link_list_session__icon" src="@/assets/arrow_right.svg" />
                </li>
              </template>

              <li v-if="false" class="category_link_list_session__item category_link_list_session__item--last">
                <a class="category_link_list_session__item_link" :href="categoryurl()">その他 カテゴリ一覧</a>
                <img class="category_link_list_session__icon" src="@/assets/arrow_right.svg" />
              </li>
            </ul>
          </div>
          <div class="category_link_list_session">
            <h2 class="category_link_list_session__header">
              {{ title }}&nbsp;に関連するページ
            </h2>
            <ul class="category_link_list_session__list" v-if="true">
              <template v-for="(item, index) in page.keywords" :key="index">
                <li class="category_link_list_session__item" :class="[
                  page.keywords.length == index + 1
                    ? 'category_link_list_session__item--last'
                    : '',
                ]">
                  <a class="category_link_list_session__item_link" :href="lpsearchurl(item.getId())">{{
                    item.getTitle() }}</a>
                  <img class="category_link_list_session__icon" src="@/assets/arrow_right.svg" />
                </li>
              </template>
              <li v-if="false" class="category_link_list_session__item category_link_list_session__item--last">
                <a class="category_link_list_session__item_link" :href="kwurl()">その他 キーワード一覧</a>
                <img class="category_link_list_session__icon" src="@/assets/arrow_right.svg" />
              </li>
            </ul>
            <p v-if="false" class="start_interview_goto_freeword">上記に当てはまらない場合</p>
            <button v-if="false" class="start_interview_btn btn_outline_primary" v-on:click="gotoFreeword">
              キーワードを入力
            </button>
          </div>
        </section>
      </div>
      <div class="border_divider"></div>
    </article>
    <div style="margin-bottom: 32px" v-if="pager.isDebug">
      <div>デバグ</div>
      <template v-for="(item, index) in page.expectations" :key="index">
        <div>
          {{ item.id }}
          <button v-on:click="page.select(item.id)">{{ item.title }}</button>
        </div>
      </template>
      <div>選択ID</div>
      <div>
        {{ page.selecteds }}
      </div>
    </div>
    <ContentsFooter :pager="pager" />
  </main>
</template>

<style scoped>
.start_interview__privacy_policy a {
  color: #444545;
}

.start_interview__privacy_policy a:visited {
  color: #444545;
}
</style>

<style scoped>
.start_interview_mark {
  width: 100%;
  position: relative;
  height: 24px;
}

.start_interview_mark__background {
  width: fit-content;
  margin: auto;
}

.start_interview_mark_overlay {
  position: absolute;
  top: 16px;
  left: 0;
  width: 100%;
}

.start_interview_mark_overlay--ar {
  top: 8px;
}

.start_interview_mark_overlay--tx {
  top: 16px;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  text-align: center;
  color: #00AEAA;
}

.start_interview_mark__background--tx {
  background: white;
}
</style>

<style scoped>
.lp_link_list__wrapper--noshadow {
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.14);
}

.lp_link_list__wrapper--top {
  padding-bottom: 0px;
}

.start_interview_wrapper {
  background: #00C9C9;
  margin-top: 24px;
  padding-top: 32px;
}

.start_interview {
  padding: 0 16px;
}

.start_interview__main_content {}
</style>

<style scoped>
.lp {
  min-height: 100vh;
  flex-flow: column;
  display: flex;
}

.main_content {
  flex: 1;
}
</style>

<style scoped>
.lpbtn {
  background: #f9fbfb;
  color: #444545;
  padding: 18px 18px;
  border: 2px solid #e2e3e3;
  border-radius: 4px;
  font-size: 14px;
  line-height: 142%;
  font-weight: bold;
  margin-top: 8px;
  cursor: pointer;
}

.lpbtn:hover {
  border: 2px solid #00c9c9;
}

.lpbtn--selected {
  background: #fff;
  border: 2px solid #00aeaa;
}

.lpbtn__description {
  font-size: 12px;
  line-height: 126%;
  font-weight: initial;
  min-height: 16px;
}
</style>

<style scoped>
.select_btn {
  width: 100%;
}

.start_interview_btn {
  width: 100%;
}

.category_title__main {
  font-size: 20px;
  font-weight: bold;
  line-height: 150%;
  margin-right: 4px;
}

.category_title__description {
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  color: #636464;
  max-width: 640px;
  margin: auto;
  padding: 0 16px;
}

.category_title__update_date {
  font-weight: 400;
  font-size: 14px;
  line-height: 142%;
  color: #636464;
  max-width: 640px;
  margin: auto;
  padding: 0 16px;
}

.start_interview__description {
  font-size: 16px;
  font-weight: 500;
  line-height: 100%;
  background: white;
  padding-top: 24px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  color: #00AEAA;
}


.start_interview__main_content {
  font-size: 13px;
  line-height: 132%;
}

.start_interview_expectations_title {
  font-size: 14px;
  font-weight: bold;
  line-height: 142%;
}
</style>

<script>
// @ is an alias to /src

// eslint-disable-next-line
import tacklebox from "tacklebox";
import ContentsHeader from "@/components/ContentsHeader.vue";
import ContentsFooter from "@/components/ContentsFooter.vue";

import { LpSearchPage } from "@/js/page/LpSearchPage.js";

export default {
  name: "LpSearchView",
  data() {
    return {
      page: new LpSearchPage(),
      isNetworking: false,
      title: "",
      lead: "",
    };
  },
  watch: {
    $route() {
      location.reload();
    }
  },
  mounted() {
    this.page.categoryId = this.$route.params.id;
    this.title = this.$route.query.title;
    this.pager.changePage(this.page);

    document.title = "FitGap | " + this.page.getTitleTag();
    this.title = this.page.getTitle();
    this.lead = this.page.getDescription();
  },
  beforeUnmount() {
    //
  },
  methods: {
    isSelected(id) {
      for (let i in this.page.selecteds) {
        if (this.page.selecteds[i] == id) {
          return true;
        }
      }
      return false;
    },
    lpsearchurl(id) {
      return process.env.VUE_APP_SELF + "/#/search/" + id;
    },
    lpurl(id, title) {
      return process.env.VUE_APP_SELF + "/#/search/" + id + "?title=" + title;
    },
    klpurl(id, title) {
      return process.env.VUE_APP_SELF + "/#/ksearch/" + id + "?title=" + title;
    },
    topurl() {
      return process.env.VUE_APP_SELF;
    },
    categoryurl() {
      return process.env.VUE_APP_SELF + "/#/category";
    },
    kwurl() {
      return process.env.VUE_APP_SELF + "/#/keyword";
    },
    gotoFreeword() {
      this.$router.push({ name: "freeword" });
    },
    termsurl() {
      return process.env.VUE_APP_SELF + "/#/terms";
    },
    policyurl() {
      return process.env.VUE_APP_SELF + "/#/policy";
    },
    startInterview() {
      const self = this;
      if (!this.page.isSelected()) {
        return;
      }
      this.isNetworking = true;
      this.page.startInterview(function (interview_id) {
        if (interview_id) {
          self.$router.push({
            name: "expectation",
            params: { id: interview_id },
          });
        } else {
          self.isNetworking = false;
        }
      });
    },
    onInterview() {
      this.$router.push("interview");
    },
  },
  components: {
    ContentsFooter,
    ContentsHeader,
  },
  props: {
    pager: Object,
  },
};
</script>
